import React, { Fragment } from 'react';

import {
    ButtonsRow,
    Column,
    ColumnContainer,
    Divider,
    MainButton,
    Paragraph,
    RatingText,
    SectionTitle,
    SubTitle,
    Tile,
    TitleContainer,
} from "@beacharound/beacharound-ui";

import { getReviews, getReviewsCounter } from "../../api/reviews";
import { useQuery } from 'react-query';
import { Link, useLocation } from 'react-router-dom';
import { getPlaceholderImage } from '../../helpers/images/getPlaceholderImage';

import { formatDistanceToNow } from 'date-fns';
import { it } from "date-fns/locale";

export default function ReviewsPlaceList({title, place, limit, beachImage}) {

    // TODO: [BEACHDEV-78] fare in modo che nella pagina delle recensioni si possa utilizzare un "more" con infinite scroll

    const { pathname } = useLocation();

    const options = {
        limit: limit || 10,
        sort: { createdAt: -1 },
        reviewed: place,
    };

    const { data: reviews } = useQuery(["reviews", options], () =>
        getReviews({ params: options }),
        {
            refetchOnWindowFocus: false
        }
    )

    const { data: reviewsCount } = useQuery(["reviews", "counter", place], () =>
        getReviewsCounter({ params: { reviewed: place } }),
        {
            refetchOnWindowFocus: false
        }
    )

    return (
        <Fragment>
            <TitleContainer>
                <SectionTitle text={title || "Recensioni"} />

                <RatingText
                    rating={reviewsCount?.median}
                    ratingsLength={reviewsCount?.count}
                />
            </TitleContainer>

            {reviews?.length <= 0 &&
                <TitleContainer>
                    <Paragraph text="Non ci sono ancora rensioni per questa attività. Lascia per primo il tuo commento!" />
                </TitleContainer>
            }

            <ButtonsRow noMargin marginTop fill>
                <MainButton
                    border
                    text="Scrivi una recensione!"
                    component={Link}
                    to={`${pathname?.replace("/recensioni","")}/recensioni/nuova`}
                />
            </ButtonsRow>

            <Divider/>

            {reviews?.map((review, index) => {
                return (
                    <ColumnContainer key={index} noMargin>
                        <Column>
                            {review.user && (
                                <Tile
                                    title={`${review.user.profile?.firstName} ${review.user.profile?.lastName}`}
                                    text={`${formatDistanceToNow(new Date(review.createdAt), {locale: it})} fa`}
                                    rounded
                                    image={review.user.profile?.image || getPlaceholderImage(undefined, undefined, "/placeholders/avatar.jpg")}
                                />
                            )}

                            {review.reviewer && !review.user && (
                                <Tile
                                    title={`${review.reviewer?.firstName} ${review.reviewer?.lastName}`}
                                    text={`${formatDistanceToNow(new Date(review.createdAt), {locale: it})} fa`}
                                    rounded
                                    image={getPlaceholderImage(undefined, undefined, "/placeholders/avatar.jpg")}
                                />
                            )}

                            {review.createdByAdmin && !review.user && (
                                <Tile
                                    title={`${review.createdByAdmin.firstName} ${review.createdByAdmin.lastName}`}
                                    text={`recensione scritta nel 2020`}
                                    rounded
                                    image={getPlaceholderImage(undefined,undefined,"/placeholders/avatar.jpg")}
                                />
                            )}

                            <TitleContainer>
                                <SubTitle color="black" text={review.title} />
                                <RatingText rating={review.vote} />
                                <Paragraph text={review.description} />
                            </TitleContainer>

                            {review.reply?.message && (
                                <Tile
                                    title="Risposta della spiaggia"
                                    text={review.reply?.message}
                                    rounded
                                    image={beachImage}
                                />
                            )}

                            <Divider />
                        </Column>
                    </ColumnContainer>
                );
            })}

            <ButtonsRow marginBottom>
                {reviews?.length < reviewsCount?.count && (
                    <MainButton
                        border
                        text="Tutte le recensioni"
                        component={Link}
                        to={`${pathname}/recensioni`}
                    />
                )}
            </ButtonsRow>
        </Fragment>
    );
}

